import { tv } from 'tailwind-variants';

const contentStyles = tv({
    slots: {
        content: "iris:p-(--comp-space-padding-card-all)",
    },
    variants: {
        imagePosition: {
            top: {},
            left: {
                content: "iris:flex iris:w-fit iris:flex-col iris:p-(--comp-space-padding-card-all)",
            },
            full: {
                content: "iris:absolute iris:inset-0 iris:z-1 iris:flex iris:flex-col iris:p-(--comp-space-padding-card-all)",
            },
        },
    },
});

export { contentStyles as default };
